import { render } from "./ListeGroupeDeTaxePage.vue?vue&type=template&id=131ffda0&ts=true"
import script from "./ListeGroupeDeTaxePage.vue?vue&type=script&lang=ts"
export * from "./ListeGroupeDeTaxePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__